import { connect } from 'react-redux';
import { mapStateToProps } from '../utils/redux';
import { isString } from 'lodash';
var DEFAULT_NAMESPACE = 'whereabouts';
/**
 * Simple HoC that just abstracts the react-redux connect out
 * We could even make it just return `connect(...)`, the whole HoC thing is mainly
 * there to be able to throw the warning in dev environment!
 * @param  {String|Function} [namespace] - Optional namespace, if you used a custom name in redux
 * @return {Function|React.Component}
 */

export default function withWhereabouts(namespace) {
  if (namespace == null) {
    // Support empty invocations
    namespace = DEFAULT_NAMESPACE;
  } else if (!isString(namespace)) {
    // Support immediate invocations with Components
    return withWhereabouts(DEFAULT_NAMESPACE)(namespace);
  }

  var connector = connect(function (state, ownProps) {
    return mapStateToProps(namespace, state, ownProps);
  });
  return function (WrappedComponent) {
    // This will map the whereabout data onto `this.props[namespace]`!
    // This means, if someone used a different name in the store creation, they will get
    // a different prop name as well ... I find that better, but its potentially confusing?
    var WithWhereabouts = connector(WrappedComponent);
    WithWhereabouts.displayName = "withWhereabouts(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
    return WithWhereabouts;
  };
}